import { denormalize } from 'normalizr';
import get from 'lodash/get';
import { getStore as getDB } from '../DB.store';
import schema from './Customer.schema';

export const DOMAIN = `db.${schema.key}`;

export const getStore = state => get(state, DOMAIN) || {};

export const getEntityById = (state, id) => denormalize(id, schema, getDB(state)) || {};
export const getEntitiesForIds = (state, ids) => denormalize(ids, [schema], getDB(state));

export const getEntityFieldById = (state, { id, field }) =>
    get(getStore(state), [id, field]) || null;

export const getOrganizations = (state, id) => get(getEntityById(state, id), 'organizations') || [];

export const getRoles = (state, id) => get(getEntityById(state, id), 'roles') || [];

export const getCustomerPlan = (state, id) => get(getEntityById(state, id), 'customerPlan') || {};
export const isInternal = (state, id) => get(getEntityById(state, id), 'isInternal') === true;
